import { Input } from "antd";
import type { InputProps } from "antd";

const MONOSPACE_FONT = "source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace";

interface CurrencyAmountInputProps extends Omit<InputProps, "onChange"> {
  currencyLabel?: string;
  onChange?: (value: string) => void;
}

export function CurrencyAmountInput({
  currencyLabel = "تومان",
  className = "",
  onChange,
  ...props
}: CurrencyAmountInputProps) {
  return (
    <>
      <style>{`
        .currency-amount-input input::placeholder {
          text-align: right;
          font-size: 14px;
          font-weight: 400;
          direction: rtl !important;
        }
      `}</style>
      <Input
        addonAfter={currencyLabel}
        size="large"
        dir="ltr"
        className={`currency-amount-input ${className}`.trim()}
        styles={{
          input: {
            fontWeight: 500,
            textAlign: "left",
            fontFamily: MONOSPACE_FONT,
            borderStartEndRadius: 10,
            borderStartStartRadius: 0,
            borderEndEndRadius: 10,
            borderEndStartRadius: 0,
          },
        }}
        onChange={(e) => onChange?.(e.target.value)}
        {...props}
      />
    </>
  );
}

export default CurrencyAmountInput;
